var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-dialog",
    {
      attrs: { "max-width": "440", persistent: "" },
      model: {
        value: _vm.show,
        callback: function($$v) {
          _vm.show = $$v
        },
        expression: "show"
      }
    },
    [
      _c(
        "v-card",
        { staticClass: "popup add_store_popup popup-success vne-modal" },
        [
          _c("i", { staticClass: "ico-success" }, [
            _c("img", {
              attrs: { src: require("@/assets/img/ico-caution.png"), alt: "" }
            })
          ]),
          _c("div", { staticClass: "msg" }, [
            _c("h3", { staticClass: "mb-1 vne-title" }, [
              _vm._v(_vm._s(_vm.$t("Vision Not Enabled")))
            ]),
            _vm.storeName || _vm.storeCode
              ? _c("p", { staticClass: "vne-store-label" }, [
                  _vm._v(" " + _vm._s(_vm.storeName)),
                  _vm.storeCode
                    ? _c("span", [_vm._v(" · " + _vm._s(_vm.storeCode))])
                    : _vm._e()
                ])
              : _vm._e()
          ]),
          _c("v-divider", { staticClass: "vne-divider" }),
          _c(
            "v-row",
            { staticClass: "mt-3 mb-1" },
            [
              _c("v-col", { staticClass: "py-0 text-center" }, [
                _c("span", { staticClass: "vne-message" }, [
                  _vm._v(
                    " " +
                      _vm._s(
                        _vm.$t(
                          "Vision is not enabled for this store. Please go to Store Settings to enable the Vision configuration."
                        )
                      ) +
                      " "
                  )
                ])
              ])
            ],
            1
          ),
          _c(
            "v-row",
            { staticClass: "pt-3" },
            [
              _c("v-col", { staticClass: "py-0" }, [
                _c(
                  "div",
                  { staticClass: "vne-note" },
                  [
                    _c(
                      "v-icon",
                      {
                        staticClass: "mr-1",
                        staticStyle: { "vertical-align": "middle" },
                        attrs: { small: "", color: "#e65100" }
                      },
                      [_vm._v("mdi-information-outline")]
                    ),
                    _c("span", [
                      _vm._v(
                        _vm._s(
                          _vm.$t(
                            "Cancelling will redirect you to the Overview page."
                          )
                        )
                      )
                    ])
                  ],
                  1
                )
              ])
            ],
            1
          ),
          _c(
            "v-card-actions",
            { staticClass: "d-flex justify-center mt-6" },
            [
              _c(
                "v-btn",
                {
                  staticClass: "btn vne-btn-primary",
                  attrs: { text: "" },
                  on: { click: _vm.onGoToStoreSettings }
                },
                [_vm._v(" " + _vm._s(_vm.$t("Store Settings")) + " ")]
              ),
              _c(
                "v-btn",
                {
                  staticClass: "btn vne-btn-cancel",
                  attrs: { text: "" },
                  on: { click: _vm.onCancel }
                },
                [_vm._v(" " + _vm._s(_vm.$t("Cancel")) + " ")]
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }